import * as React from "react";

import { SectionCommon } from "./layout/section-common";
import { TrustedByLogos } from "./trusted-by-logos";
import { ArrowButton } from "./arrow-button";

export interface TrustedbyEntity {
  alt: string;
  src: string;
  className?: string;
  styles?: React.CSSProperties;
}

export const TrustedBy = ({
  trustedByEntities,
  styles
}: {
  trustedByEntities: TrustedbyEntity[];
  styles?: React.CSSProperties;
}) => (
  <SectionCommon
    title="Trusted by 1,000+ Clients Across the World"
    text="Powering agencies from North America to Australia in hundreds of industries and niches."
    classNames="text-center"
    styles={styles}
  >
    <TrustedByLogos trustedByEntities={trustedByEntities} />
    <ArrowButton href="/results" text="See results" style={{marginTop: 'var(--small)'}} />
  </SectionCommon>
);
